interface WhatsAppFloatProps {
  showTooltip: boolean;
  onCloseTooltip: () => void;
}

export default function WhatsAppFloat({ showTooltip, onCloseTooltip }: WhatsAppFloatProps) {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5512981309575', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {showTooltip && (
        <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-xl p-4 max-w-xs animate-fadeIn">
          <button
            onClick={onCloseTooltip}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 cursor-pointer"
          >
            <i className="ri-close-line"></i>
          </button>
          <div className="pr-6">
            <h4 className="font-semibold text-gray-900 mb-2">💬 Precisa de ajuda?</h4>
            <p className="text-sm text-gray-600 mb-3">
              Converse conosco no WhatsApp e descubra como acelerar o crescimento do seu negócio!
            </p>
            <button
              onClick={handleWhatsAppClick}
              className="bg-green-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Iniciar Conversa
            </button>
          </div>
          <div className="absolute bottom-[-8px] right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white"></div>
        </div>
      )}

      <button
        onClick={handleWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 animate-pulse cursor-pointer"
        title="Fale conosco no WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </div>
  );
}
